import React, { useState, useEffect } from 'react';

export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const links = [
    { label: 'About', href: '#about' },
    { label: 'Services', href: '#services' },
    { label: 'Projects', href: '#projects' },
    { label: 'Gallery', href: '#gallery' },
  ];

  return (
    <>
      <nav className={`fixed top-0 left-0 right-0 z-[1000] flex items-center justify-between transition-all duration-400 ${scrolled ? 'py-3 px-8 md:px-16 bg-white/[0.96] backdrop-blur-[12px] shadow-[0_1px_30px_rgba(0,0,0,0.08)]' : 'py-5 px-8 md:px-16 bg-transparent'}`}>
        {/* Logo — small green-bg icon + text brand */}
        <a href="#hero" className="flex items-center gap-3 no-underline">
          <img
            src="/logo.png"
            alt="Nestlent"
            className="h-9 w-9 object-contain rounded-sm"
          />
          <div className="leading-none">
            <div className={`font-brand text-[1.35rem] tracking-[0.08em] transition-colors duration-400 ${scrolled ? 'text-nestlent-charcoal' : 'text-white'}`}>
              NESTLENT
            </div>
            <div className={`text-[0.5rem] font-light tracking-[0.2em] mt-0.5 transition-colors duration-400 ${scrolled ? 'text-nestlent-green' : 'text-nestlent-green-mid'}`}>
              Where Happiness Resides
            </div>
          </div>
        </a>

        {/* Desktop Links */}
        <ul className="hidden lg:flex items-center gap-10 list-none">
          {links.map(l => (
            <li key={l.label}>
              <a
                href={l.href}
                className={`relative text-[0.78rem] font-normal tracking-[0.12em] uppercase no-underline transition-colors duration-300 group ${scrolled ? 'text-nestlent-grey hover:text-nestlent-green' : 'text-white/85 hover:text-white'}`}
              >
                {l.label}
                <span className="absolute -bottom-[3px] left-0 right-full h-px bg-nestlent-green-mid transition-all duration-300 group-hover:right-0" />
              </a>
            </li>
          ))}
          <li>
            <a
              href="#footer"
              className="text-[0.75rem] font-medium tracking-[0.12em] uppercase text-white bg-nestlent-green px-5 py-2.5 rounded-sm no-underline transition-all duration-300 hover:bg-nestlent-green-light hover:-translate-y-px"
            >
              Get in Touch
            </a>
          </li>
        </ul>

        {/* Hamburger */}
        <button
          className="lg:hidden flex flex-col gap-[5px] cursor-pointer p-1 bg-transparent border-none"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle menu"
        >
          <span className={`block w-6 h-[1.5px] transition-all duration-300 ${scrolled ? 'bg-nestlent-charcoal' : 'bg-white'}`} />
          <span className={`block w-6 h-[1.5px] transition-all duration-300 ${scrolled ? 'bg-nestlent-charcoal' : 'bg-white'}`} />
          <span className={`block w-6 h-[1.5px] transition-all duration-300 ${scrolled ? 'bg-nestlent-charcoal' : 'bg-white'}`} />
        </button>
      </nav>

      {/* Mobile Overlay */}
      {isOpen && <div className="fixed inset-0 z-[998] bg-black/50" onClick={() => setIsOpen(false)} />}

      {/* Mobile Menu */}
      <div className={`fixed top-0 right-0 w-[280px] h-screen bg-nestlent-charcoal z-[999] pt-20 px-8 pb-8 transition-transform duration-400 shadow-[-10px_0_50px_rgba(0,0,0,0.4)] lg:hidden ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}>
        <div className="flex items-center gap-3 mb-10">
          <img src="/logo.png" alt="Nestlent" className="h-9 w-9 object-contain rounded-sm" />
          <div className="font-brand text-[1.2rem] text-white tracking-[0.08em]">NESTLENT</div>
        </div>
        <ul className="list-none space-y-6">
          {[...links, { label: 'Contact', href: '#footer' }].map(l => (
            <li key={l.label}>
              <a
                href={l.href}
                onClick={() => setIsOpen(false)}
                className="text-base text-white/70 no-underline tracking-[0.08em] hover:text-nestlent-green-mid transition-colors duration-300"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}
